import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '@/views/Login.vue'),
    meta: { title: '登录', noAuth: true }
  },
  {
    path: '/planList',
    name: 'PlanList',
    component: () => import(/* webpackChunkName: "plan" */ '@/views/PlanList.vue'),
    meta: { title: '计划管理' }
  },
  {
    path: '/sheetList',
    name: 'SheetList',
    component: () => import(/* webpackChunkName: "sheet" */ '@/views/SheetList.vue'),
    meta: { title: '测评列表' }
  },
  {
    path: '/sheet/:sheetId',
    name: 'SheetDetail',
    component: () => import(/* webpackChunkName: "sheet" */ '@/views/SheetDetail.vue'),
    meta: { title: '测评详情' }
  },
  {
    path: '/sheet/by-login/:loginId',
    name: 'SheetDetailByLogin',
    component: () => import(/* webpackChunkName: "sheet" */ '@/views/SheetDetail.vue'),
    meta: { title: '测评详情' }
  },
  {
    path: '/planProgress',
    name: 'PlanProgress',
    component: () => import(/* webpackChunkName: "progress" */ '@/views/PlanProgress.vue'),
    meta: { title: '测评进度' }
  },
  {
    path: '/planStatistics',
    name: 'PlanStatistics',
    component: () => import(/* webpackChunkName: "statistics" */ '@/views/PlanStatistics.vue'),
    meta: { title: '统计分析' }
  },
  {
    path: '/plan-ai-analyze',
    name: 'PlanAiAnalyze',
    component: () => import(/* webpackChunkName: "statistics" */ '@/views/PlanAiAnalyze.vue'),
    meta: { title: 'AI分析结果' }
  },
  {
    path: '/scaleRule',
    name: 'ScaleRule',
    component: () => import(/* webpackChunkName: "system" */ '@/views/system/ScaleRule.vue'),
    meta: { title: '' }
  },
  {
    path: '/profileField',
    name: 'ProfileField',
    component: () => import(/* webpackChunkName: "system" */ '@/views/system/ProfileField.vue'),
    meta: { title: '登录填写项' }
  },
  {
    path: '/',
    redirect: '/planList'
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

// 忽略导航重定向/重复等预期内错误，避免触发 Uncaught runtime errors 遮罩
router.onError((err) => {
  const msg = err && (err.message || err)
  if (typeof msg === 'string' && (msg.includes('Redirected') || msg.includes('NavigationDuplicated') || msg.includes('Avoided redundant navigation'))) {
    return
  }
  throw err
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title + ' - 湃云团体心理测评后台'
  }
  if (to.meta.noAuth) {
    next()
    return
  }
  if (!store.state.user.token) {
    next({ path: '/login', query: { redirect: to.fullPath } })
    return
  }
  next()
})

export default router
